import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import TourDisposition from './TourDisposition'
import WaveDisposition from './WaveDisposition'

const Wrapper = styled.div``

const DispositionSettings = (props) => {
  const { id } = props

  if (id === 'tour') {
    return <TourDisposition />
  }

  if (id === 'wave') {
    return <WaveDisposition />
  }

  return null
}

export default DispositionSettings
